import cloneDeep from 'lodash.clonedeep';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i2 from "../../../../../../ycharts/static/ts/features/components/inputs/checkbox-group/checkbox-group.component";
const OWNER_OPTIONS = [
    {
        label: 'Me',
        value: 'me',
        checked: true,
    },
    {
        label: 'Shared with me',
        value: 'shared_with_me',
        checked: true,
    },
];
const OWNER_PUBLIC_OPTION = {
    label: 'Public',
    value: 'public',
    checked: true,
};
const INCLUDE_EMPTY_FOLDERS_FILTER = [
    {
        label: 'Show empty folders',
        value: 'includeEmptyFolders',
        checked: false,
    },
];
export class FolderableOpenSavedFilterComponent {
    constructor(folderableCollectionService) {
        this.folderableCollectionService = folderableCollectionService;
        this.maxLength = 255;
    }
    ngOnInit() {
        this.ownerOptions = OWNER_OPTIONS.map((o) => ({ ...o }));
        if (this.publicSharing) {
            this.ownerOptions.push({ ...OWNER_PUBLIC_OPTION });
        }
        this.includeEmptyFoldersFilter = INCLUDE_EMPTY_FOLDERS_FILTER.map((o) => ({ ...o }));
        if (this.folderableCollectionService.dataParams?.owner) {
            this.mapStateToOwnerOptions(this.folderableCollectionService.dataParams.owner);
            this.includeEmptyFoldersFilter[0].checked =
                this.folderableCollectionService.dataParams.includeEmptyFolders ?? false;
        }
        this.folderableCollectionSubscription = this.folderableCollectionService.viewResponse$.subscribe((response) => {
            if (response === null)
                return;
            this.mapStateToOwnerOptions(response.params.owner);
            this.includeEmptyFoldersFilter[0].checked = response.params.includeEmptyFolders ?? false;
        });
    }
    ngOnDestroy() {
        // Optional-chain: when the component is conditionally rendered (e.g. via @if in
        // SelectFolderableModalComponent), Angular can destroy it before ngOnInit has
        // assigned the subscription. The field is declared with `!:`, so it can be
        // undefined at this point. (Sentry: ANGULAR-1477)
        // eslint-disable-next-line no-unused-expressions
        this.folderableCollectionSubscription?.unsubscribe();
    }
    mapStateToOwnerOptions(filter) {
        this.ownerOptions = this.ownerOptions.map((option) => {
            return {
                ...option,
                checked: filter[option.value],
            };
        });
    }
    setOwner(checkBoxResults) {
        const params = cloneDeep(this.folderableCollectionService.dataParams);
        params.owner = checkBoxResults;
        this.folderableCollectionService.refreshData(params);
    }
    setIncludeEmptyFolders(checkBoxResults) {
        const params = cloneDeep(this.folderableCollectionService.dataParams);
        params.includeEmptyFolders = checkBoxResults.includeEmptyFolders;
        this.folderableCollectionService.refreshData(params);
    }
}
FolderableOpenSavedFilterComponent.ɵfac = function FolderableOpenSavedFilterComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableOpenSavedFilterComponent)(i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase)); };
FolderableOpenSavedFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableOpenSavedFilterComponent, selectors: [["ycn-folderable-open-saved-filter"]], inputs: { publicSharing: "publicSharing", maxLength: "maxLength" }, standalone: false, decls: 9, vars: 6, consts: [[1, "modal-section", "bg-panel", "pt-12", "pb-12"], [1, "form-inline", "mb-1"], [1, "form-label", "form-label-thin", "mr-2"], [3, "checkedHandler", "groupName", "displayVertical", "options"], [1, "form-inline"]], template: function FolderableOpenSavedFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "Owner:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "ycn-checkbox-group", 3);
        i0.ɵɵlistener("checkedHandler", function FolderableOpenSavedFilterComponent_Template_ycn_checkbox_group_checkedHandler_4_listener($event) { return ctx.setOwner($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 2);
        i0.ɵɵtext(7, "Folders:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-checkbox-group", 3);
        i0.ɵɵlistener("checkedHandler", function FolderableOpenSavedFilterComponent_Template_ycn_checkbox_group_checkedHandler_8_listener($event) { return ctx.setIncludeEmptyFolders($event); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("groupName", "ownerCheckboxGroup")("displayVertical", false)("options", ctx.ownerOptions);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("groupName", "includeEmptyFoldersCheckboxGroup")("displayVertical", false)("options", ctx.includeEmptyFoldersFilter);
    } }, dependencies: [i2.CheckboxGroupComponent], encapsulation: 2 });
